import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_AUDIT_TABLE,
  API_URL_AUDIT_TABLE_FILTERS,
} from 'constants/index'
import {
  AUDIT_FETCH_TABLE,
  AUDIT_FETCH_TABLE_FILTERS,
  AUDIT_SET_TABLE,
  AUDIT_SET_TABLE_FILTERS,
} from './reducer'

function* auditFetchTableData(action) {
  try {
    const data = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_AUDIT_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    yield put({
      type: AUDIT_SET_TABLE,
      tableData: data,
    })
  } catch (error) {
    console.log('AUDIT INTERFACE ERROR', error)
  }
}

function* auditFetchTableFilters() {
  try {
    const data = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_AUDIT_TABLE_FILTERS,
    })

    yield put({
      type: AUDIT_SET_TABLE_FILTERS,
      tableFilters: data,
    })
  } catch (error) {
    console.log('AUDIT INTERFACE ERROR', error)
  }
}

function* auditSaga() {
  yield takeLatest(AUDIT_FETCH_TABLE, auditFetchTableData)
  yield takeLatest(AUDIT_FETCH_TABLE_FILTERS, auditFetchTableFilters)
}

export default auditSaga
